"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugWarn = void 0;
/**
 * If the app is in debug mode, prints a warning to the console. In production builds, this function does nothing.
 *
 * @param args
 */
const debugWarn = (...args) => {
    if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn(...args);
    }
};
exports.debugWarn = debugWarn;
